export const DEFAULT_MOBILE_FOOTER = "games-six";

export const MOBILE_FOOTER_OPTIONS = [
  {
    id: "games-six",
    label: "Games bar",
    hint: "Default. Games chip + 6 tabs.",
    preview: "/images/footers/games-six.png",
  },
  {
    id: "default",
    label: "Raised Home",
    hint: "5 tabs with a raised Home button.",
    preview: "/images/footers/default.png",
  },
  {
    id: "home-arc",
    label: "Home glow",
    hint: "5 tabs, filled Home arc.",
    preview: "/images/footers/home-arc.png",
  },
  {
    id: "games-five",
    label: "Games compact",
    hint: "Games chip + 5 tabs, no Multi Markets.",
    preview: "/images/footers/games-five.png",
  },
] as const;

export const MOBILE_FOOTER_IDS = MOBILE_FOOTER_OPTIONS.map((item) => item.id);

export const normalizeMobileFooterId = (value?: string | null) => {
  const id = String(value || "").trim();
  if (!id) return DEFAULT_MOBILE_FOOTER;
  if (id === "games-fill" || id === "games-bar" || id === "games-six") return "games-six";
  if (id === "home-bump" || id === "home-raised" || id === "default") return "default";
  if (id === "home-arc" || id === "games-five") return id;
  return DEFAULT_MOBILE_FOOTER;
};
